// extracted by mini-css-extract-plugin
export default {"tile":"ActionTile_tile__CC-p5","title":"ActionTile_title__z5DQy","description":"ActionTile_description__NPHPb","button":"ActionTile_button__XO+LL"};